import { Injectable } from '@angular/core';
import { HttpClient, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs/Rx';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';
import { LayoutService } from '../services/layout.service';
import { DhhpAlertComponent } from '../../shared/dhhpalert/dhhpalert.component';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  subscriptionAuth: Subscription;
  userType: string = '';
  constructor(private translate: TranslateService, private router: Router, private dhhpAlert: DhhpAlertComponent, public http: HttpClient, private authService: AuthService, private userService: LayoutService) { }
  getUserType(): any {
    this.subscriptionAuth = this.userService.getProfileData$.subscribe(res => {
      if (Object.keys(res).length) {
        this.userType = res.accountType;
        if (this.subscriptionAuth)
          this.subscriptionAuth.unsubscribe();
      }
    });
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = this.authService.getAccessToken();
    if (token != null) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    //Retained the old logic to review if there is any issue. Remove the commented code after few testing cycles.
    // return next.handle(req).catch(err => {
    //   if (err.status === 401) {
    //     if (this.authService.getRefreshToken() != null) {
    //       this.getUserType();
    //       let params = {
    //         "refreshToken": this.authService.getRefreshToken(),
    //         "sessionId": localStorage.getItem('sessionId')
    //       };
    //       if(this.userType == 'Hartmann'){
    //         return this.http.post(environment.PLATFORM_AUTH + "Account/RefreshTokenByHartmannUser", params).flatMap(
    //           (data: any) => {
    //             //If reload successful update tokens
    //             if (data.access_token != null) {
    //               this.authService.setAccessToken(data.access_token)
    //               this.authService.setRefreshToken(data.refresh_token);
    //               req = req.clone({
    //                 setHeaders: {
    //                   Authorization: `Bearer ${data.access_token}`
    //                 }
    //               });
    //               return next.handle(req).catch((err) => {
    //                 return Observable.throwError(err);
    //               });
    //             } else { }
    //           }
    //         );
    //       } else {
    //       return this.http.post(environment.PLATFORM_AUTH + "Account/RefreshToken", params).flatMap(
    //         (data: any) => {
    //           //If reload successful update tokens
    //           if (data.access_token != null) {
    //             this.authService.setAccessToken(data.access_token)
    //             this.authService.setRefreshToken(data.refresh_token);
    //             req = req.clone({
    //               setHeaders: {
    //                 Authorization: `Bearer ${data.access_token}`
    //               }
    //             });
    //             return next.handle(req).catch((err) => {
    //               return Observable.throwError(err);
    //             });
    //           } else { }
    //         }
    //       )};
    //     } else { }
    //   }
    //   if (err.status === 502 || err.status === 0 || err.status === 500) {
    //     if(this.authService.loggedIn()){
    //       this.router.navigateByUrl('/internal/internal-error');
    //     }else{
    //       this.router.navigateByUrl('/internal-error');
    //     }
    //   }
    //   if (err.status != 502 && err.status != 0 && err.status != 500 && err.status != 401) {
    //     if(err.error && err.error.error_code) {
    //       if(err.error.error_code == this.translate.instant(err.error.error_code)){
    //         this.dhhpAlert.dhhpAlertError(this.translate.instant(err.error.message), '');
    //       }else{
    //         this.dhhpAlert.dhhpAlertError(this.translate.instant(err.error.error_code), '');
    //       }
    //     }
    //   }
    //   return Observable.throwError(err);
    // });
    return next.handle(req).pipe(catchError((err) => {
      if (err.status === 401) {
        if (this.authService.getRefreshToken() != null) {
          this.getUserType();
          let params = {
            "refreshToken": this.authService.getRefreshToken(),
            "sessionId": localStorage.getItem('sessionId')
          };
          if (this.userType == 'Hartmann') {
            return this.http.post(environment.PLATFORM_AUTH + "Account/RefreshTokenByHartmannUser", params).flatMap(
              (data: any) => {
                //If reload successful update tokens
                if (data.access_token != null) {
                  // this.authService.setAccessToken(data.access_token)
                  // this.authService.setRefreshToken(data.refresh_token);
                  req = req.clone({
                    setHeaders: {
                      Authorization: `Bearer ${data.access_token}`
                    }
                  });
                  return next.handle(req).catch((err) => {
                    return Observable.throwError(err);
                  });
                } else { }
              }
            );
          } else {
            return this.http.post(environment.PLATFORM_AUTH + "Account/RefreshToken", params).flatMap(
              (data: any) => {
                //If reload successful update tokens
                if (data.access_token != null) {
                  // this.authService.setAccessToken(data.access_token)
                  // this.authService.setRefreshToken(data.refresh_token);
                  req = req.clone({
                    setHeaders: {
                      Authorization: `Bearer ${data.access_token}`
                    }
                  });
                  return next.handle(req).catch((err) => {
                    return Observable.throwError(err);
                  });
                } else { }
              }
            )
          };
        } else { }
      }
      if (err.status === 502 || err.status === 0 || err.status === 500) {
        // if (this.authService.loggedIn()) {
        //   this.router.navigateByUrl('/internal/internal-error');
        // } else {
        //   this.router.navigateByUrl('/internal-error');
        // }
      }
      if (err.status != 502 && err.status != 0 && err.status != 500 && err.status != 401) {
        if (err.error && err.error.error_code) {
          if (err.error.error_code == this.translate.instant(err.error.error_code)) {
            this.dhhpAlert.dhhpAlertError(this.translate.instant(err.error.message), '');
          } else {
            this.dhhpAlert.dhhpAlertError(this.translate.instant(err.error.error_code), '');
          }
        }
      }
      return throwError(() => err);
    }));
  }
}